import _ from "lodash";

export const camelcaseKeys = <T>(object: T): T => {
  return _.mapKeys(object, (v, k) => _.camelCase(k));
};

export const snakecaseKeys = <T>(object: T): T => {
  return _.mapKeys(object, (v, k) => _.snakeCase(k));
}
